import styled, { keyframes } from 'styled-components';

export const SimpleFade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Icon = styled.div`
  align-self: center;
  display: grid;
  cursor: pointer;
`;

export const Logo = styled.img`
  width: 101.17px;
  margin-left: 16px;
  cursor: pointer;
  user-select: none;
  opacity: 0;
  animation: ${SimpleFade} 0.6s ease 0.1s forwards;
`;

export const Right = styled.div`
  display: grid;
  justify-self: end;
  margin-right: 42px;
  justify-content: center;
  opacity: 0;
  animation: ${SimpleFade} 0.6s ease 0.1s forwards;

  > svg {
    display: none;
    cursor: pointer;
  }
`;

export const IconMobile = styled.div`
  align-self: center;
  display: grid;
  cursor: pointer;
  display: none;
`;


export const Wrapper = styled.div`
  height: 56px;
  width: 100vw;
  background: #ffffff;
  display: grid;
  box-shadow: inset 0px -1px 0px #e2e2ea;
  align-items: center;
  grid-template-columns: repeat(2, auto);
  z-index: 11;
  /* overflow: hidden; */
  display: none;

  @media (max-width: 767px) {
    display: grid;
    ${Right} {
      ${IconMobile} {
        display: grid;
      }
      margin-right: 16px;
      > svg {
        display: block;
      }
    }
  }
`;
